import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 480);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-156" data-mp="4kgbzdy7i7tc">
      {scrolled && <motion.header initial={{
      y: -80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -80,
      opacity: 0
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} className="fixed inset-x-0 top-0 z-50 border-b border-sand bg-cream/90 backdrop-blur-md" data-id="element-157" data-mp="4lhzwj0bmosh">
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3" data-id="element-158" data-mp="9mnt0hxw8e2j">
            <div className="flex items-baseline gap-2" data-id="element-159" data-mp="1q0dzfvchjefc">
              <span className="font-serif text-lg font-semibold text-sage-deep" data-id="element-160" data-mp="1kyomub9m6sp5">Yoga 360</span>
              <span className="hidden text-xs uppercase tracking-widest text-muted sm:inline" data-id="element-161" data-mp="9nfz2oljtgw2">
                RecursosFitness™
              </span>
            </div>
            <div className="flex items-center gap-4" data-id="element-162" data-mp="jmx18w1ldcna">
              <div className="hidden text-right sm:block" data-id="element-163" data-mp="jn6vwwxl07zb">
                <span className="text-xs text-muted line-through" data-id="element-164" data-mp="om07gjtb5owu">$69.990</span>
                <span className="ml-2 font-serif text-lg font-semibold text-ink" data-id="element-165" data-mp="3n3m9cmgtouf2">Hoy $27.990</span>
              </div>
              <a href="https://yoga-360.impultienda.ar/checkout" className="rounded-full bg-clay px-5 py-2 text-sm font-semibold text-cream transition-colors hover:bg-[#bf6f87]" data-id="element-166" data-mp="3s1ns16ac6rq0">
                Comprar ahora
              </a>
            </div>
          </div>
        </motion.header>}
    </AnimatePresence>;
}